// Single source of truth for responsive breakpoints, mirroring the Tailwind
// theme (Tailwind v4 defaults — see src/styles/tailwind.css, which does not
// override the default `--breakpoint-*` values). If a breakpoint changes in
// Tailwind, update it here too; breakpoints.spec.ts guards the drift.
export const BREAKPOINTS = { sm: 640, md: 768, lg: 1024, xl: 1280 } as const

export type Breakpoint = keyof typeof BREAKPOINTS

// "Mobile" = below the md breakpoint. Subtracting 0.02px avoids a 1px dead zone
// at exactly 768 where neither this max-width query nor Tailwind's min-width
// `md:` utilities would apply.
export const MOBILE_MAX_PX = BREAKPOINTS.md - 0.02
export const MOBILE_MEDIA_QUERY = `(max-width: ${MOBILE_MAX_PX}px)`
